import { ComponentType } from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";

interface Props {
    children: React.ReactNode;
    FallbackComponent?: ComponentType<FallbackProps>;
}

const ErrorHandler = (props: Props) => {
    return (
        <ErrorBoundary
            FallbackComponent={props.FallbackComponent}
            // onReset={() => {
            //   if(trendsModalShow){
            //     dispatch(updateTrendsDataOne([]));
            //     dispatch(updateTrendsDataTwo([]));
            //     dispatch(updateTrendsModal(false));
            //   }
            // }}
        >
            {props.children}
        </ErrorBoundary>
    );
};

export default ErrorHandler;
